// Splits a list of areas in two by a yes/no question, and orders each half. The Real Time list
// asks "is it monitored?", the Origin-Destination list asks "is it selected?". Pure: no React,
// router or Firebase imports.

/**
 * `matching` holds the areas for which `predicate` is true, `rest` the others. Inside each half
 * areas with a lower `rank` come first, then they are ordered by name. Without a `rank` the order
 * is by name alone. Returns new arrays; the input is untouched.
 */
export function partitionBy<T extends { name: string }>(
  areas: readonly T[],
  predicate: (area: T) => boolean,
  rank: (area: T) => number = () => 0,
): { matching: T[]; rest: T[] } {
  const sorted = [...areas].sort((a, b) => rank(a) - rank(b) || a.name.localeCompare(b.name));
  return {
    matching: sorted.filter((a) => predicate(a)),
    rest: sorted.filter((a) => !predicate(a)),
  };
}
